export default "__VITE_ASSET__6g0n4OmX__"